<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="SaaS利用設定"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!-- VPN/VNコード -->
                <v-row>
                  <v-col cols="12">
                    <app-badge
                      item="VPN/VNコード"
                      :isInfo="false"
                      :isRequired="!saas"
                    />
                    <validation-provider
                      v-if="!saas"
                      name="form.connectDest"
                      label="VPN/VNコード"
                      v-model="form.connectDest"
                      :rules="{ required: true }"
                      v-slot="{ componentField, errorMessage }"
                    >
                      <app-multi-select
                        :options="vpnVnCodeOptions"
                        label="vpnVnCode"
                        track-by="vpnVnCode"
                        group-label="vpnVnCodeLabel"
                        group-values="vpnVnCodeValues"
                        :multiple="false"
                        :custom-label="formatConnectDest"
                        v-bind="componentField"
                        :error-messages="errorMessage"
                      >
                        <template #option="{ option }">
                          <template v-if="option.$isLabel">
                            <div class="multiselect-thead">
                              <p class="v-col-3 pa-0">
                                {{ option.$groupLabel.vpnVnCode }}
                              </p>
                              <p class="v-col-8 pa-0">
                                {{ option.$groupLabel.vnName }}
                              </p>
                            </div>
                          </template>
                          <div class="multiselect-tbody">
                            <p class="v-col-3 pa-0">{{ option.vpnVnCode }}</p>
                            <p class="v-col-8 pa-0">{{ option.vnName }}</p>
                          </div>
                        </template>
                      </app-multi-select>
                    </validation-provider>
                    <span v-else class="ml-3">
                      <span v-if="saas.saasCommon.vnName">
                        {{ saas.saasCommon.vnName + " : " }}
                      </span>
                      {{ saas.saasCommon.vpnVnCode }}
                    </span>
                  </v-col>
                </v-row>

                <!-- Microsoft Peering -->
                <v-row>
                  <v-col cols="12">
                    <app-badge
                      item="Microsoft Peering"
                      :isRequired="false"
                      :isInfo="false"
                    />
                    <v-radio-group
                      v-model="form.hasMSPeering"
                      inline
                      hide-details
                    >
                      <v-radio label="利用しない" :value="false"></v-radio>
                      <v-radio label="利用する" :value="true"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <!-- NAPTアドレス上限数 -->
                <v-row>
                  <v-col cols="12">
                    <app-badge
                      item="NAPTアドレス上限数"
                      :isRequired="form.hasMSPeering"
                      :isInfo="form.hasMSPeering"
                      :msg="$filter.message('info_half_width_number')"
                    />
                    <validation-provider
                      v-if="form.hasMSPeering"
                      label="NAPTアドレス上限数"
                      name="hasMSPeering1"
                      :rules="{
                        required: true,
                        numeric: true,
                        between: { min: 1, max: 100 },
                      }"
                      v-model.number="form.msUpperLimitNapt"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input-number
                        v-bind="componentField"
                        :disabled="!form.hasMSPeering"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                        class="v-col-5 pa-0"
                      />
                    </validation-provider>
                    <app-form-input-number
                      v-else
                      disabled
                      class="v-col-5 pa-0"
                    />
                  </v-col>
                </v-row>

                <!-- NATアドレス上限数 -->
                <v-row>
                  <v-col cols="12">
                    <app-badge
                      item="NATアドレス上限数"
                      :isRequired="form.hasMSPeering"
                      :isInfo="form.hasMSPeering"
                      :msg="$filter.message('info_half_width_number')"
                    />
                    <validation-provider
                      v-if="form.hasMSPeering"
                      label="NATアドレス上限数"
                      name="hasMSPeering2"
                      :rules="{
                        required: true,
                        numeric: true,
                        between: { min: 0, max: 100 },
                      }"
                      v-model.number="form.msUpperLimitNat"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input-number
                        v-bind="componentField"
                        :disabled="!form.hasMSPeering"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                        class="v-col-5 pa-0"
                      />
                    </validation-provider>
                    <app-form-input-number
                      v-else
                      disabled
                      class="v-col-5 pa-0"
                    />
                  </v-col>
                </v-row>

                <!-- Salesforce -->
                <v-row>
                  <v-col cols="12">
                    <app-badge
                      item="Salesforce"
                      :isRequired="false"
                      :isInfo="false"
                    />
                    <v-radio-group v-model="form.hasSfdc" inline hide-details>
                      <v-radio label="利用しない" :value="false"></v-radio>
                      <v-radio label="利用する" :value="true"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <!-- NAPTアドレス上限数 -->
                <v-row>
                  <v-col cols="12">
                    <app-badge
                      item="NAPTアドレス上限数"
                      :isRequired="form.hasSfdc"
                      :isInfo="form.hasSfdc"
                      :msg="$filter.message('info_half_width_number')"
                    />
                    <validation-provider
                      v-if="form.hasSfdc"
                      label="NAPTアドレス上限数"
                      name="hasSfdc"
                      :rules="{
                        required: true,
                        numeric: true,
                        between: { min: 1, max: 5 },
                      }"
                      v-model.number="form.sfdcUpperLimitNapt"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input-number
                        v-bind="componentField"
                        :disabled="!form.hasSfdc"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                        class="v-col-5 pa-0"
                      />
                    </validation-provider>
                    <app-form-input-number
                      v-else
                      disabled
                      class="v-col-5 pa-0"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>

          <!-- モーダルフッター -->
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">{{
                  saas ? "変更" : "追加"
                }}</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { SaaSListEntity } from "@/views/nwSetting/saas/SaaSServiceApplicationList.vue";
import { VueFinalModal } from "vue-final-modal";

export interface VpnVnCodeEntity {
  vpnVnCode: string;
  vnName: string;
}

type vpnVnCodeOption = {
  vpnVnCodeLabel: { vpnVnCode: string; vnName: string };
  vpnVnCodeValues: VpnVnCodeEntity[];
};

export default defineComponent({
  name: "SaaSServiceUsageEdit",
  props: {
    /**
     * SaaS利用設定情報.
     */
    saas: {
      type: Object as PropType<SaaSListEntity>,
      required: false,
    },
    /** 設定追加・変更時、使用する排他キー */
    saasKeyId: {
      type: String as PropType<string>,
      required: true,
    },
    /** 一覧に存在しているVpnVnCodeリスト */
    existVpnVnCodeList: {
      type: Array as PropType<string[]>,
      required: false,
    },
  },
  data() {
    return {
      isLoaded: false,
      form: {
        connectDest: null as null | VpnVnCodeEntity,
        hasMSPeering: false,
        msUpperLimitNapt: 1,
        msUpperLimitNat: 0,
        hasSfdc: false,
        sfdcUpperLimitNapt: 1,
      },
      vpnVnCodeList: [] as VpnVnCodeEntity[],
    };
  },
  computed: {
    // VPN/VNコード : 検索付きプールダウンのタイトルと選択肢表示
    vpnVnCodeOptions(): vpnVnCodeOption[] {
      return this.vpnVnCodeList.length !== 0
        ? [
            {
              vpnVnCodeLabel: {
                vpnVnCode: "VPN/VNコード",
                vnName: "VNネットワーク名",
              },
              vpnVnCodeValues: this.vpnVnCodeList,
            },
          ]
        : [];
    },
  },

  async mounted() {
    /** VPN/VNコードの検索付きプールダウンデータ取得 */
    /**
     * VPNコード設定
     * VN情報取得 : 仮想ネットワーク一覧からL3のみのVNコード・VN名取得
     */
    if (!this.saas) {
      // 追加の場合のみ
      const vpnVn = (await this.$api.information.getVpnVnCodeList()).filter(
        (e) =>
          (e.vnType === "L3" || e.vnType === null) &&
          !this.existVpnVnCodeList?.includes(e.vpnVnCode)
      );
      this.vpnVnCodeList = vpnVn.map((e) => ({
        vpnVnCode: e.vpnVnCode,
        vnName: e.vnName ?? "-",
      }));
    }

    /** Microsoft Peering変更時、既存のデータを表示する表示マッピング */
    if (this.saas?.msPeeringInfo?.msPeering) {
      this.form.hasMSPeering = true;
      this.form.msUpperLimitNapt =
        this.saas.msPeeringInfo.msPeering.upperLimitNapt;
      this.form.msUpperLimitNat =
        this.saas.msPeeringInfo.msPeering.upperLimitNat;
    }

    /** Salesforce変更時、既存のデータを表示する表示マッピング */
    if (this.saas?.sfdcInfo?.sfdc) {
      this.form.hasSfdc = true;
      this.form.sfdcUpperLimitNapt = this.saas.sfdcInfo.sfdc.upperLimitNapt;
    }
    this.isLoaded = true;
  },
  methods: {
    /** VPN/VNコード選択後の表示形式 */
    formatConnectDest({ vpnVnCode, vnName }: VpnVnCodeEntity) {
      return vnName && vnName !== "-"
        ? `${vpnVnCode} : ${vnName}`
        : `${vpnVnCode}`;
    },

    async submit() {
      if (!this.saas) {
        /** 追加確認ダイアログ */
        await this.$confirm("SaaS利用設定を追加します。よろしいですか？");
        /** SaaS利用設定情報を追加API呼び出し処理 */
        await this.$api.saas.post({
          saasCommon: {
            vpnVnCode: this.form.connectDest!.vpnVnCode,
          },
          msPeeringInfo: {
            msServiceSeq: null,
            msPeering: this.form.hasMSPeering
              ? {
                  upperLimitNapt: this.form.msUpperLimitNapt,
                  upperLimitNat: this.form.msUpperLimitNat,
                }
              : null,
          },
          sfdcInfo: {
            sfdcServiceSeq: null,
            sfdc: this.form.hasSfdc
              ? {
                  upperLimitNapt: this.form.sfdcUpperLimitNapt,
                }
              : null,
          },
          saasKeyId: this.saasKeyId,
        });
      } else {
        /** 変更確認ダイアログ */
        await this.$confirm("SaaS利用設定を変更します。よろしいですか？");
        /** SaaS利用設定情報を変更API呼び出し処理 */
        await this.$api.saas.post({
          saasCommon: {
            vpnVnCode: this.saas.saasCommon.vpnVnCode,
          },
          msPeeringInfo: {
            msServiceSeq: this.saas.msPeeringInfo?.msServiceSeq
              ? this.saas.msPeeringInfo.msServiceSeq
              : null,
            msPeering: this.form.hasMSPeering
              ? {
                  upperLimitNapt: this.form.msUpperLimitNapt,
                  upperLimitNat: this.form.msUpperLimitNat,
                }
              : null,
          },
          sfdcInfo: {
            sfdcServiceSeq: this.saas.sfdcInfo?.sfdcServiceSeq
              ? this.saas.sfdcInfo.sfdcServiceSeq
              : null,
            sfdc: this.form.hasSfdc
              ? {
                  upperLimitNapt: this.form.sfdcUpperLimitNapt,
                }
              : null,
          },
          saasKeyId: this.saasKeyId,
        });
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
